import Vue from 'vue';
import Vuex from 'vuex';

import account from '@imemento/spa-helpers/src/modules/account.module.js';
import alert from '@imemento/spa-helpers/src/modules/alert.module.js';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    alert,
    account,
  }
});
